<template>
  <Footer class="app-footer">
    <p>© 2023 亚信科技（中国）有限公司 版权所有</p>
  </Footer>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-footer {
    margin: 40px 0 0 0;
    padding: 10px 24px;
    color: @subsidiary-color;
    background-color: white;
    border-top: 1px solid @box-border-inner-color;
  }
</style>
